<template>
<main-content>
    
</main-content>
</template>

<script>
import mainContent from './Base'

export default {
    components: {
        'main-content': mainContent
    },
    beforeRouteEnter (to, from, next) {
        next(vm => vm.$store.dispatch('user/fetchCurrent'))
    },
}
</script>

<style>

</style>